import React from 'react';
import tpl from '../templates/brokerage-services';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'DigitalSkins';
}
